import { apiUrl, authHeaders } from "./httpAuth";

export async function fetchPersonasAll() {
    const res = await fetch(apiUrl("api/personas/all"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}

export async function fetchTitulares() {
    const res = await fetch(apiUrl("api/personas/titulares"), { headers: authHeaders() });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
}
